import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { Vue } from 'vue-class-component';
var WEmpty = /*#__PURE__*/function (_Vue) {
  function WEmpty() {
    _classCallCheck(this, WEmpty);
    return _callSuper(this, WEmpty, arguments);
  }
  _inherits(WEmpty, _Vue);
  return _createClass(WEmpty);
}(Vue);
export { WEmpty as default };